import { MiniReact } from "../src/index";

/** @jsx MiniReact.createElement */
const Route = _ref => {
  let {
    path,
    component
  } = _ref;
  return MiniReact.createElement(component);
};
export default Route;